import React, { CSSProperties } from 'react';
import { useRecoilValue } from 'recoil';
import { LazyImageLoader } from '../product_detail/components/LazyImageLoader';
import { shopifyState } from '../recoil/atoms';
import { sizeImage } from '../util';
import styles from './GuaranteePanel.module.scss';

interface Props {
  image?: string;
  guarantees: Guarantee[];
  style?: CSSProperties;
}

export interface Guarantee {
  message: string;
  usaOnly?: boolean;
}

const Guarantee: React.FC<Pick<Guarantee, 'message'>> = ({ message }) => {
  return <span>▹ {message}</span>;
};

export const GuaranteePanel: React.FC<Props> = ({ image, guarantees, style }) => {
  const shopify = useRecoilValue(shopifyState);
  const customerInUsa = shopify?.currency.active === 'USD';
  const visibleGuarantees = customerInUsa ? guarantees : guarantees.filter((g) => !g.usaOnly);

  if (visibleGuarantees.length === 0) return <></>;

  return (
    <div className={styles.container} style={style}>
      {image && <LazyImageLoader alt="Guarantees" src={sizeImage(image, 'x80')} height="40" />}
      <div className={styles.guaranteeList}>
        {visibleGuarantees.map((g, i) => (
          <Guarantee key={i} message={g.message} />
        ))}
      </div>
    </div>
  );
};

export default GuaranteePanel;
